import React, { useState, useEffect } from "react";
import OtpInput from "react-otp-input";
import { useSelector, useDispatch } from "react-redux";
import { verifyMobileOtpapi } from "../../redux/formslice"
import { setotpmodal } from "../../redux/formslice";
import { reSendOtpeOtp, reSendOtpWhatsapp } from "../../services/Apis";
export default function OtpVerifiaction() {

    const [otp, setOtp] = useState("");
    const dispatch = useDispatch()
    const registermobile = useSelector(state => state.formslice.registermobile);
    const checkotperror = useSelector(state => state.formslice.checkotperror);
    const currentcountry = useSelector((state) => state.globalslice.currentcountry);

    const verifyotp = () => {
        const input_data = {
            "mobile": registermobile,
            "otp": otp
        }
        dispatch(verifyMobileOtpapi(input_data))
    }

    const handleClose = () => {
        dispatch(setotpmodal(false))
    }


    const [timer, setTimer] = useState(20);
    const [canResend, setCanResend] = useState(false);

    useEffect(() => {
        if (timer > 0) {
            const interval = setInterval(() => {
                setTimer(prev => prev - 1);
            }, 1000);

            return () => clearInterval(interval);
        } else {
            setCanResend(true);
        }
    }, [timer]);

    const handleResend = (type) => {
        // 👇 your resend OTP API call here
        var input_data = {
            "mobile": registermobile
        }
        if (type == 1) {
            reSendOtpeOtp(input_data)
        } else {
            reSendOtpWhatsapp(input_data)
        }

        // restart timer
        setTimer(20);
        setCanResend(false);
    };

    return (
        <div className="otpverification-main">
            <div style={{ "-webkit-text-fill-color": 'transparent' }} className="FormHeading">
                Verify Phone Number
            </div>
            <div className="formsubheading mt-2">
                To proceed to checkout, use the OTP & verify your mobile number.
            </div>
            <div className="formsubheading">
                We`ve sent the OTP to {currentcountry.country_code}-{registermobile}
            </div>
            <div className="formsubheading">
                Change Number? <span className="link_custome" onClick={handleClose}>Click Here</span>
            </div>
            <OtpInput
                value={otp}
                onChange={setOtp}
                inputType={'tel'}
                numInputs={4}
                renderSeparator={<span className="mx-2">   </span>}
                renderInput={(props) => (
                    <input
                        {...props}
                        className="otpinput mt-4"
                    />
                )}
            />
            {
                timer > 0 &&
                <p className="mt-3">Resend OTP in {timer} sec</p>
            }
            <div className="otperror">{checkotperror}</div>


            <div
                className="formsubmitbutton activeformsubmitbutton"
                onClick={verifyotp}
            >
                Submit & verify
            </div >

            <div className="d-flex my-3">
                <span className={`me-5 link_custome ${timer > 0 && 'custom_disabled'}`} onClick={() => handleResend(1)}>Resened Otp Via Sms</span>
                <span className={`me-5 link_custome ${timer > 0 && 'custom_disabled'}`} onClick={() => handleResend(2)}>Resened Otp Via Whatsapp</span>
            </div>
        </div>
    );
}
